export default "__VITE_ASSET__30be8620__"